module.exports = __webpack_public_path__ + "img/kefu.a162f632.png";